// Marketplace icons as inline SVG data URLs for reliability

// Wildberries - Purple gradient with "wb" text
export const WILDBERRIES_ICON = `data:image/svg+xml,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <linearGradient id="wbGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#CB11AB"/>
      <stop offset="100%" style="stop-color:#7B2D8E"/>
    </linearGradient>
  </defs>
  <rect width="100" height="100" rx="20" fill="url(#wbGrad)"/>
  <text x="50" y="62" font-family="Arial, sans-serif" font-size="36" font-weight="bold" fill="white" text-anchor="middle">wb</text>
</svg>
`)}`;

// Ozon - Blue circle with white "ozon" text
export const OZON_ICON = `data:image/svg+xml,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <circle cx="50" cy="50" r="50" fill="#005BFF"/>
  <path d="M25 50 L40 35 L40 65 Z" fill="#E5004C" opacity="0.8"/>
  <text x="50" y="58" font-family="Arial, sans-serif" font-size="22" font-weight="bold" fill="white" text-anchor="middle">ozon</text>
</svg>
`)}`;

// Yandex Market - Orange circle with yellow M
export const YANDEX_MARKET_ICON = `data:image/svg+xml,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <circle cx="50" cy="50" r="48" fill="#FF5722"/>
  <path d="M25 75 L40 25 L50 55 L60 25 L75 75 L60 75 L55 55 L50 70 L45 55 L40 75 Z" fill="#FFD600"/>
</svg>
`)}`;

export const MARKETPLACE_ICONS = {
  wildberries: WILDBERRIES_ICON,
  ozon: OZON_ICON,
  yandex_market: YANDEX_MARKET_ICON,
};

export default MARKETPLACE_ICONS;

